import React from 'react';
import styled from 'styled-components';
import { panel } from './panelTheme';

// UNA LINEA FRA DUE GRUPPI DI PARAMETRI DELLA STESSA CARD.
//
// Sembra decorazione e non lo è: dice dove passa un confine che altrimenti si scoprirebbe solo
// cambiando qualcosa. Nel pannello di una luce, sopra ci sono le manopole che qualunque luce ha —
// intensità, colore — e sotto quelle che esistono solo per QUESTA specie, il cono di un faretto o
// la portata di una puntiforme: cambiando tipo è la parte di sotto a cambiare, e la linea è ciò
// che lo lascia prevedere.
//
// NIENTE LINEA SE SOTTO NON C'È NIENTE: chi costruisce la card la mette solo quando ha davvero due
// parti da separare — un divisore che non separa niente promette una seconda metà che non arriva.
const Rule = styled.hr`
    width: 100%;
    height: 1px;
    margin: 2px 0;
    border: 0;
    background: ${panel.line};
`;

export type PropertiesPanelDividerProps = {
    id: string;
};

export const PropertiesPanelDivider: React.FC = () => <Rule aria-hidden='true' />;
